import { createGlobalStyle } from 'styled-components';

import reset from './reset';

import '@assets/fonts/icons/style.css';
import '@assets/fonts/fonts.css';

import { ViewModeQueries } from '@helpers/viewModeHelper';

const GlobalStyle = createGlobalStyle`
  ${reset}

  // additional reset
  * {
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
    -webkit-font-smoothing: antialiased;
  }
  a {
    color: inherit;
    cursor: pointer;
  }
  button {
    cursor: pointer;
    padding: 0;
    background: transparent;
    border: none;
    outline: none;
  }
  input {
    font: inherit;
  }
  // additional reset
  
  // fix for user agent stylesheet
  button, textarea {
    font: inherit;
  }
  // fix for user agent stylesheet

  html, body {
    height: 100%;
  }
  html {
    ${({ theme }) => theme.fonts.primary.fontSize};
    scroll-behavior: smooth;
  }
  body {
    font-family: ${({ theme }) => theme.fonts.primary.fontFamily};
    color: ${({ theme }) => theme.colors.text.default};
    background-color: ${({ theme }) => theme.colors.background};
  }
  #root {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  a.link_external {
    color: ${(props) => props.theme.colors.primary_lighter};
  }
  .nowrap {
    white-space: nowrap;
  }
  span .react-loading-skeleton {
    border-radius: ${(props) => props.theme.borderRadius.r8};
    line-height: inherit;
  }
  
  .primaryColor {
    color: ${({ theme }) => theme.colors.primary};
  }
  .infoColor {
    color: ${({ theme }) => theme.colors.info};
  }
  
  .html-renderer {
    p {
      font-size: ${(props) => props.theme.spaces.s12};
      line-height: ${(props) => props.theme.spaces.s16};

      ${ViewModeQueries.MD} {
        font-size: 14px;
        line-height: 18px;
      }
    }

    strong {
      font-weight: bold;
    }
    ul, ol {
      margin: 10px 0;
    }
    i, em {
      font-style: italic;
    }
    u {
      text-decoration: underline;
    }
    ul {
      list-style: disc inside none;
    }
    ol {
      list-style: decimal inside none;
    }
    ul li, ol li {
      margin: 2px 0;
    }
    h1 {
      font-weight: ${(props) => props.theme.fonts.h1.fontWeight};
      font-size: ${(props) => props.theme.fonts.h1.fontSize};
      line-height: ${(props) => props.theme.fonts.h1.lineHeight};

      ${ViewModeQueries.MD} {
        font-size: ${(props) => props.theme.fonts.h1.fontSize_md};
        line-height: ${(props) => props.theme.fonts.h1.lineHeight_md};
      }
    }
    h2 {
      font-weight: ${(props) => props.theme.fonts.h2.fontWeight};
      font-size: ${(props) => props.theme.fonts.h2.fontSize};
      line-height: ${(props) => props.theme.fonts.h2.lineHeight};

      ${ViewModeQueries.MD} {
        font-size: ${(props) => props.theme.fonts.h2.fontSize_md};
        line-height: ${(props) => props.theme.fonts.h2.lineHeight_md};
      } 
    }
    h3 {
      font-weight: ${(props) => props.theme.fonts.h3.fontWeight};
      font-size: ${(props) => props.theme.fonts.h3.fontSize};
      line-height: ${(props) => props.theme.fonts.h3.lineHeight};

      ${ViewModeQueries.MD} {
        font-size: ${(props) => props.theme.fonts.h3.fontSize_md};
        line-height: ${(props) => props.theme.fonts.h3.lineHeight_md};
      } 
    }
  }
`;

export default GlobalStyle;
